import { render } from "./NoPermission.vue?vue&type=template&id=3bd8a8d6"
import script from "./NoPermission.vue?vue&type=script&lang=js"
export * from "./NoPermission.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\cs-player\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__